import type { JSX, ReactNode } from 'react';

const Error = ({ children, className, id }: { children?: ReactNode; className?: string; id?: string }): JSX.Element | null => {
  return children ? (
    <p id={id} className={className || 'text-pbk-14 py-1 text-red-500'}>
      {children}
    </p>
  ) : null;
};

export default Error;
